export const MF_HOLDINGS_DISCLAIMERS = [
    'A detailed list of fund holdings are as of the date shown. Holdings are made available 15 calendar days after quarter end and 30 calendar days after non-quarter end months. Holdings are shown as of the date indicated and are subject to change.',
    "The identity of certain securities may have been concealed to protect the fund's interests",
    'Figures may not total due to rounding.',
    'Prior to May 31, 2024, the information shown does not reflect any ETFs that may have been held by the fund.'
];

// Treating disclaimers for Semi-Transparent ETFs as separate from the Mutual Fund ones as
// they are almost guaranteed to change later according to business requirements.
export const ETF_HOLDINGS_DISCLAIMERS = [
    'A detailed list of fund holdings are as of the date shown. Holdings are made available 15 calendar days after quarter end and 30 calendar days after non-quarter end months. Holdings are shown as of the date indicated and are subject to change.',
    "The identity of certain securities may have been concealed to protect the fund's interests",
    'Figures may not total due to rounding.',
    'Prior to May 31, 2024, the information shown does not reflect any ETFs that may have been held by the fund.'
];

export const getCsvDisclaimer = (isEtf, isMonthly) => {
    if (!isEtf) {
        return MF_HOLDINGS_DISCLAIMERS.join('\n').replace(/,/g, ' ');
    }

    if (isEtf && isMonthly) {
        return ETF_HOLDINGS_DISCLAIMERS.join('\n').replace(/,/g, ' ');
    }

    return null;
};
